import { render, staticRenderFns } from "./theBasicLevel.vue?vue&type=template&id=5f240629&scoped=true&"
import script from "./theBasicLevel.vue?vue&type=script&lang=js&"
export * from "./theBasicLevel.vue?vue&type=script&lang=js&"
import style0 from "./theBasicLevel.vue?vue&type=style&index=0&id=5f240629&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f240629",
  null
  
)

export default component.exports